import utils from "../../../utils";
import customAxios from "../../customAxios";

import {UPDATE_SCHOOL} from "./../../routes";
import {ICreateAndUpdateSchool} from "../../../types/school.interface";

const updateSchool = async (formData: ICreateAndUpdateSchool) => {
  try {
    return (
      await customAxios.put(UPDATE_SCHOOL + `/${formData._id}`, {
        ...formData,
        city: formData.city?._id,
        area: formData?.area?._id,
        province: formData.province?._id,
        neighborhood: formData?.neighborhood?._id,
        grade: utils.convertSchoolGrade.htmlToMongo(formData.grade),
      })
    ).data;
  } catch (error: unknown) {
    console.error({UPDATE_SCHOOL: error});
    return false;
  }
};

export default updateSchool;
